var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { XSDDate } from 'lincd-xsd/shapes/XSDDate.js';
import { Literal } from 'lincd/models';
import { literalProperty, objectProperty } from 'lincd/shapes/SHACL';
import { schema } from '../ontologies/schema.js';
import { getPackageShape, linkedShape, packageName } from '../package.js';
import { Thing } from './Thing.js';
let CreativeWork = class CreativeWork extends Thing {
    get creator() {
        return this.getOneAs(schema.creator, getPackageShape('Person'));
    }
    set creator(val) {
        this.overwrite(schema.creator, val ? val.namedNode : null);
    }
    get creditText() {
        return this.getValue(schema.creditText);
    }
    set creditText(val) {
        this.overwrite(schema.creditText, new Literal(val));
    }
    //@TODO: remove this once weve got a better solution for circular dependencies (see Thing get/set Image)
    get usageInfo() {
        return this.getValue(schema.usageInfo);
    }
    set usageInfo(val) {
        this.overwrite(schema.usageInfo, new Literal(val));
    }
    get copyrightNotice() {
        return this.getValue(schema.copyrightNotice);
    }
    set copyrightNotice(val) {
        this.overwrite(schema.copyrightNotice, new Literal(val));
    }
    get text() {
        return this.getValue(schema.text);
    }
    set text(val) {
        this.overwrite(schema.text, new Literal(val));
    }
    get dateCreated() {
        return XSDDate.toNativeDate(this.getOne(schema.dateCreated));
    }
    set dateCreated(val) {
        this.overwrite(schema.dateCreated, XSDDate.fromNativeDate(val).node);
    }
    get dateModified() {
        return XSDDate.toNativeDate(this.getOne(schema.dateModified));
    }
    set dateModified(val) {
        this.overwrite(schema.dateModified, XSDDate.fromNativeDate(val).node);
    }
    get headline() {
        return this.getValue(schema.headline);
    }
    set headline(val) {
        this.overwrite(schema.headline, new Literal(val));
    }
};
CreativeWork.targetClass = schema.CreativeWork;
__decorate([
    objectProperty({
        path: schema.creator,
        maxCount: 1,
        shape: [packageName, 'Person'],
    }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], CreativeWork.prototype, "creator", null);
__decorate([
    literalProperty({
        path: schema.creditText,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], CreativeWork.prototype, "creditText", null);
__decorate([
    literalProperty({
        path: schema.usageInfo,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], CreativeWork.prototype, "usageInfo", null);
__decorate([
    literalProperty({
        path: schema.copyrightNotice,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], CreativeWork.prototype, "copyrightNotice", null);
__decorate([
    literalProperty({
        path: schema.text,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], CreativeWork.prototype, "text", null);
__decorate([
    literalProperty({
        path: schema.dateCreated,
        maxCount: 1,
        datatype: XSDDate.targetClass,
    }),
    __metadata("design:type", Date),
    __metadata("design:paramtypes", [Date])
], CreativeWork.prototype, "dateCreated", null);
__decorate([
    literalProperty({
        path: schema.dateModified,
        maxCount: 1,
        datatype: XSDDate.targetClass,
    }),
    __metadata("design:type", Date),
    __metadata("design:paramtypes", [Date])
], CreativeWork.prototype, "dateModified", null);
__decorate([
    literalProperty({
        path: schema.headline,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], CreativeWork.prototype, "headline", null);
CreativeWork = __decorate([
    linkedShape({
        description: 'A work or composition that is the result of creative effort. Represents content with creator, dates, and copyright info. (content, work, creation)',
    })
], CreativeWork);
export { CreativeWork };
//# sourceMappingURL=CreativeWork.js.map